import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  trainingDetails: {
    marginBottom: '1rem',
  },

  trainingHead: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1.3rem',
  },

  trainingName: {
    flex: 1,
  },

  buttons: {
    '& button[class^="btn-"]:first-child': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },

    '& button[class^="btn-"]:last-child': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      marginLeft: 0,
      borderLeft: 0,
    },
  },

  testsHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1.1rem',
  },

  testsTitle: {
    flex: '1',
  },
})

export default useStyles
